export default function Logo({ className = "h-9 w-9" }) {
  return (
    <img
      data-testid="kataco-logo"
      src="/logo.png"
      alt="KATACO"
      className={`${className} rounded-full object-cover`}
    />
  );
}
